import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2da44c04")

_pushScopeId("data-v-2da44c04")
const _hoisted_1 = { class: "modal bg_white flex_centered column" }
const _hoisted_2 = { class: "checkBoxContainer" }
const _hoisted_3 = { class: "page_padding text-center" }
const _hoisted_4 = { class: "flex_centered" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "app_Vuoiscartarepiùvelocemente<br/>iprofilichenontiinteressano?",
        text: "Vuoi scartare più velocemente <br />i profili che non ti interessano?",
        class: "fev_text5 bg_brand_error bg_on_text fw_600"
      }),
      _createVNode("div", {
        class: "d-flex align-items-center justify-content-center mt-3",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dontShowAnymore = !_ctx.dontShowAnymore))
      }, [
        _createVNode("div", {
          class: ["sameAsCheckbox", { 'selected' : _ctx.dontShowAnymore}]
        }, null, 2),
        _createVNode(_component_localized_text, {
          localizedKey: "app_Nonmostrarepiùquestoavviso",
          text: "Non mostrare più questo avviso",
          class: "fw_600 fev_text5 ms-2"
        })
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        type: "h2",
        class: "fw_700 text-center mb-3",
        localizedKey: "app_Unavoltascartatoilprofilononpotràpiùessererecuperatato.<br/>Vuoiprocedere?",
        text: "Una volta scartato il profilo non potrà più essere recuperatato. <br />Vuoi procedere?"
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("button", {
        class: "fev_button big transparent bg_brand_error bg_on_text w-50",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextProfile(_ctx.dontShowAnymore)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Si",
          text: "Si"
        })
      ]),
      _createVNode("button", {
        class: "fev_button big transparent bg_brand bg_on_text w-50",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.stay(_ctx.dontShowAnymore)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_No",
          text: "No"
        })
      ])
    ])
  ]))
})